import React from 'react';
import { styled } from '@compiled/react';
import { Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import { useIntl } from '@atlassian/jira-intl';
import { useIsSimplifiedProject } from '@atlassian/jira-providers-project-context';
import { JsmPageInteractiveEvent } from '@atlassian/jira-servicedesk-common/src/utils/browser-metric/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import messages from './messages';

export const GlobalObjectPanel = () => {
	const intl = useIntl();
	const isAdmin = useIsAdmin();
	const isSimplifiedProject = useIsSimplifiedProject();

	return (
		<>
			<JsmPageInteractiveEvent />
			<Header>{intl.formatMessage(messages.header)}</Header>
			<Inline xcss={boxStyles}>{intl.formatMessage(messages.description)}</Inline>
			{isAdmin ? (
				<ul>
					<li>
						<Link href="/secure/admin/ViewPriorities.jspa">
							{intl.formatMessage(messages.prioritiesLabel)}
						</Link>
					</li>
					{!isSimplifiedProject && (
						<li>
							<Link href="/secure/admin/ViewResolutions.jspa">
								{intl.formatMessage(messages.resolutionsLabel)}
							</Link>
						</li>
					)}
				</ul>
			) : (
				<>
					<ul>
						<li>{intl.formatMessage(messages.prioritiesLabel)}</li>
						<li>{intl.formatMessage(messages.resolutionsLabel)}</li>
					</ul>
					<p>{intl.formatMessage(messages.contactDescription)}</p>
				</>
			)}
		</>
	);
};

const boxStyles = xcss({
	maxWidth: '600px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Header = styled.h4({
	fontWeight: '400',
	marginBottom: token('space.400', '32px'),
	marginTop: token('space.150', '12px'),
});
